module.exports = __webpack_public_path__ + "img/4m2.c5f57f32.jpg";